import type * as FeaturedDailyArticle from '../types/FeaturedDailyArticle'
import { imageParser } from '../props/parsers/Image'

export default function featuredDailyArticleComponentParser(
  rawComponent: FeaturedDailyArticle.Raw,
): FeaturedDailyArticle.Parsed | undefined {
  const [props] = rawComponent.featuredDailyArticle

  if (!props) {
    return undefined
  }

  const { image, ...rest } = props

  return {
    name: 'FeaturedDailyArticle',
    props: {
      ...imageParser(image),
      ...rest,
    },
  }
}
